import styled, { css } from 'styled-components'

import { Link as DefaultLink } from '@subaio/components'

import { helpers } from 'styles'

type Props = {
	isActive?: boolean
}

export const Link = styled(DefaultLink)<Props>`
	display: block;
	padding: 4px 16px;
	margin: 0 -16px;
	width: calc(100% + 16px);
	font-weight: 500;
	color: ${helpers.color.textHeader};

	&:focus {
		text-decoration: none;
	}

	&:hover {
		text-decoration: none;
		color: ${helpers.color.link};
	}

	&:is(:active, :focus-visible) {
		text-decoration: none;
		color: ${helpers.color.text};
	}

	${({ isActive = false, theme }) =>
		isActive &&
		css`
		color: ${theme.color.link};
		background-color: ${helpers.color.linkBackgroundActive};
	`}
`
